import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  params: ['person'],
  validate (value, { person }) {
    const valid = true;
    const today = new UtcDate();
    const birthDate = new UtcDate(value);
    const personAgeAtLatestInsuranceStart = today.differenceInYears(birthDate);
    if (personAgeAtLatestInsuranceStart < this.constants.INSURER_MIN_AGE) return `${person} age must be at least ${this.constants.INSURER_MIN_AGE} years.`;
    return {
      valid,
      required: true,
    };
  },
};
